export const DEFAULT_LANGUAGE = 'ru';

/**
 * Picks the first browser language the page has a locale for, matching on the primary subtag
 * (`de-AT` → `de`). Anything unsupported, or no browser languages at all, gives Russian.
 */
export function detectLanguage(
  browserLanguages: readonly string[],
  supported: readonly string[],
): string {
  for (const tag of browserLanguages) {
    const primary = tag.split(/[-_]/)[0].trim().toLowerCase();
    if (supported.includes(primary)) {
      return primary;
    }
  }
  return DEFAULT_LANGUAGE;
}

export function browserLanguages(): string[] {
  if (typeof navigator === 'undefined') {
    return [];
  }
  if (navigator.languages && navigator.languages.length > 0) {
    return Array.from(navigator.languages);
  }
  return navigator.language ? [navigator.language] : [];
}
